import { render, staticRenderFns } from "./SectionDetail.vue?vue&type=template&id=100cbc5c&"
import script from "./SectionDetail.vue?vue&type=script&lang=js&"
export * from "./SectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SectionDetail.vue"
export default component.exports